import { template } from "@ember/template-compiler";
import Component from "@glimmer/component";
import { cached } from "@glimmer/tracking";
import { getOwner, setOwner } from "@ember/owner";
import { service } from "@ember/service";
import ApiSection from "./api-section";
import PanelHeader from "./panel-header";
export default class SidebarApiSections extends Component {
    @service
    sidebarState;
    get sections() {
        let sectionConfigs1;
        if (this.sidebarState.combinedMode) {
            sectionConfigs1 = this.sidebarState.panels.filter((panel1)=>!panel1.hidden).flatMap((panel1)=>panel1.sections);
        } else {
            sectionConfigs1 = this.sidebarState.currentPanel.sections;
        }
        return sectionConfigs1.map((Section1)=>{
            const SidebarSection1 = prepareSidebarSectionClass(Section1);
            const sectionInstance1 = new SidebarSection1({
                filterable: !this.sidebarState.combinedMode && this.sidebarState.currentPanel.filterable,
                sidebarState: this.sidebarState
            });
            setOwner(sectionInstance1, getOwner(this));
            return sectionInstance1;
        });
    }
    get filteredSections() {
        return this.sections.filter((section1)=>section1.filtered);
    }
    static{
        template(`
    <PanelHeader @sections={{this.filteredSections}} />

    {{#each this.filteredSections as |section|}}
      <ApiSection @section={{section}} @collapsable={{@collapsable}} />
    {{/each}}
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
}
// extends the class provided for the section to add functionality we don't want to be overridable when defining custom
// sections using the plugin API, like for example the filtering capabilities
function prepareSidebarSectionClass(Section1) {
    return class extends Section1 {
        constructor({ filterable: filterable1, sidebarState: sidebarState1 }){
            super();
            this.filterable = filterable1;
            this.sidebarState = sidebarState1;
        }
        @cached
        get filteredLinks() {
            if (!this.filterable || !this.sidebarState.filter) {
                return this.links;
            }
            if (this.text?.toLowerCase()?.match(this.sidebarState.sanitizedFilter)) {
                return this.links;
            }
            return this.links.filter((link1)=>{
                return (link1.text.toString().toLowerCase().match(this.sidebarState.sanitizedFilter) || link1.keywords.navigation.some((keyword1)=>keyword1.match(this.sidebarState.sanitizedFilter)));
            });
        }
        get filtered() {
            return !this.filterable || this.filteredLinks?.length > 0;
        }
    };
}
